/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createPaymentCardsRepository = (options: RestApiOptions): Types.PaymentCardsRepository => ({
    async authorize(params, requestOptions) {
        return options.request('/paymentCards/authorize', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getAll(params, requestOptions) {
        return options.request('/paymentCards/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
